<div class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Amend cheque purpose</h1>
    <app-navpath />
  </div>
  <div class="mb-2 flex w-fit gap-1">
    <button
      class="shorter-btn save-btn"
      [disabled]="lockUpdate"
      (click)="update()"
    >
      <fa-icon [icon]="faPencil" class="mr-1" />Update
    </button>
    <button class="shorter-btn clear-btn" (click)="clear()">
      <fa-icon [icon]="faBroom" class="mr-1" />Clear
    </button>
  </div>
  <div class="content-container">
    <app-data-form [dataFields]="form" (clickSearch)="search()" />
  </div>
</div>
